const ScreenType = new Map();

ScreenType.set('homeScreen', 1);
ScreenType.set('postDetailScreen', 2);
ScreenType.set('postDetailRelevant', 3);

export default ScreenType;
